module.exports = __webpack_public_path__ + "许炜-569c8d2b.png";